import React, { useState } from "react";
import { Row, Col, Container, Button, Collapse, Nav } from "reactstrap";
import { NavItem, NavText } from "@trendmicro/react-sidenav";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import Logo from "../../atoms/logo";
import T from "../../atoms/translate";

function ExplorerBar({ callBack, project, workflows, expanded }) {
  const [openList, setOpenList] = useState(true);
  let prevent = false;
  const delay = 200;
  const handleClick = (value) => {
    setTimeout(() => {
      if (!prevent) {
        callBack.onSelect(value);
      }
      prevent = false;
    }, delay);
  };
  const handleDoubleClick = (e) => {
    prevent = true;
    e.stopPropagation();
    e.preventDefault();
  };
  return (
    <>
      <div
        className="vh-100 box-shadow-right"
        style={{ backgroundColor: "#f7f7f7", width: "220px" }}
      >
        <Container>
          <Row className="mt-3 mb-4">
            <Col xs="9" className="">
              <Logo />
            </Col>
          </Row>
          <Row>
            <Col xs="12" className="intro_step1">
              <h1 className="font-size-08 text-primary fw-500 mb-1">
                <T i18nKey="proyecto" />:{" "}
                <span className="font-size-09 text-body fw-400">
                  {project.name}
                </span>
              </h1>
            </Col>
          </Row>
          <Row>
            <Col xs="12" className="text-center">
              <span
                onClick={() => handleClick("config")}
                className="font-size-08 text-primary text-underline cursor-pointer"
              >
                <T i18nKey="configuracion" />
              </span>
            </Col>
          </Row>
          <Row className="my-4">
            <Col xs="12" className="intro_step4">
              <Button
                color="primary"
                block
                className="fw-500"
                size="sm"
                style={{ borderRadius: "0.4rem" }}
                onClick={() => handleClick("new")}
                onDoubleClick={handleDoubleClick}
              >
                <FontAwesomeIcon icon={faPlusCircle} className="mt-1" />{" "}
                <T i18nKey="agregarWorkflow" />
              </Button>
            </Col>
          </Row>
          <Row className="workflow-menu pt-2 intro_step3">
            <Col xs="8" className="mt-1">
              <span className="font-size-09 fw-500 text-primary">
                <T i18nKey="workflows" />
              </span>
            </Col>
            <Col
              xs="4"
              className="text-right cursor-pointer"
              onClick={() => setOpenList(!openList)}
            >
              <FontAwesomeIcon
                icon={openList ? faAngleUp : faAngleDown}
                className="mt-1 font-size-12 text-warning"
              />
            </Col>
            <Col xs="12" className="mt-2">
              <Collapse
                isOpen={openList}
                className="workflows-container overflow-scroll-hidden"
              >
                <Nav vertical className="workflow-list">
                  {workflows.map((o, key) => (
                    <NavItem
                      key={key}
                      eventKey={o.id}
                      className="workflow-item py-1"
                      onClick={() => handleClick(o.id)}
                      onDoubleClick={handleDoubleClick}
                    >
                      <NavText>{o.slug}</NavText>
                    </NavItem>
                  ))}
                </Nav>
              </Collapse>
            </Col>
          </Row>
        </Container>
        <div className="fixed-bottom intro_step2" style={{ width: "220px" }}>
          <Button
            className="rounded-0 py-3"
            block
            color="primary"
            onClick={() => handleClick("MR")}
            onDoubleClick={handleDoubleClick}
          >
            <Row>
              <Col xs="6">
                <span className="font-size-09 fw-600">
                  <T i18nKey="modelos" />
                </span>
              </Col>
              <Col xs="6">
                <span className="font-size-07">
                  <T i18nKey="verDiagrama" />
                </span>
              </Col>
            </Row>
          </Button>
        </div>
      </div>
    </>
  );
}
export default ExplorerBar;
